import Vue from 'vue'
import { Component } from 'vue-property-decorator'

// @ts-ignore
import { export_json_to_excel as exportJSONToExcel } from './excel-export/Export2Excel.js'

@Component
export default class ExportExcel extends Vue {
  tHeaders: string[][] = [] // 设置Excel的表格第一行的标题
  filterVals: string[][] = [] // index、nickName、name是tableData里对象的属性
  tableDatas: {
    [key: string]: string;
  }[][] = []
  tTitle = ''

  sheetNames: string[] = [] // 表格名

  fileName = '导出文件'

  export2Excel () {
    require.ensure([], () => {
      const list = this.tableDatas // 把data里的tableData存到list
      const data = this.formatJson(this.filterVals, list)
      exportJSONToExcel(this.tHeaders, data, this.fileName, this.sheetNames, this.tTitle) // 导出Excel 文件名
    })
  }

  formatJson (filterVals: any, jsonDatas: any) {
    const res = []
    for (let i = 0; i < filterVals.length; i++) {
      res.push(jsonDatas[i].map((v: any) => filterVals[i].map((j: any) => v[j])))
    }
    return res
  }
}
